import converter from '../../utils/converter';
import helpers from '../../utils/helpers';
import {log} from '../log';
import IqosBleClient from './iqosBleClient';
import cmMessageRequestService from '../communicationLayer/cmMessageRequestService';

let subscribedCharacteristics = [];

const subscribeToCharacteristic = async (statusPropertyName, uuid) => {
    const iqosBleClient = new IqosBleClient();
    const characteristic = await iqosBleClient.getPrimaryServiceCharacteristic(uuid);
    const DEBOUNCE_TIMEOUT_MS = 1000;
    const onCharacteristicMessageDebounced = helpers.debounce(onCharacteristicMessage, DEBOUNCE_TIMEOUT_MS);

    iqosBleClient.addCharacteristicListener(characteristic, (value) => {
        const frame = converter.buffer2hex(value);

        log.debug('onCharacteristicMessage: ' + statusPropertyName + ' - ' + frame);
        onCharacteristicMessageDebounced(statusPropertyName, value);
    });
    subscribedCharacteristics.push(uuid);
};

const onCharacteristicMessage = (statusPropertyName, value) => {
    const frame = converter.buffer2hex(value);

    log.debug('onCharacteristicMessageDebounced: ' + statusPropertyName + ' - ' + frame);
    cmMessageRequestService.publishCharacteristicEvent({[statusPropertyName]: {frame}});
};

const removeCharacteristicsListeners = () => {
    const iqosBleClient = new IqosBleClient();

    subscribedCharacteristics.forEach((uuid) => {
        iqosBleClient.removeCharacteristicListenerByUuid(uuid);
    });

    subscribedCharacteristics = [];
};

export default {
    subscribeToCharacteristic,
    removeCharacteristicsListeners,
};
